<template>
	<div class="container">
		<div class="top_title">
			<router-link class="icon_back" :to="{name: 'H050020', params:{searchInput:searchInput,I_LEVEL_CODE:I_LEVEL_CODE,I_FLAG:I_FLAG,tabFlag:tabFlag}}"
			 tag="span"></router-link>
			<p>{{info.I_TITLE_1}}</p>
			<span style="float: right;position: absolute;top: 0;right: 0.6rem;" @click="openBook">
				<span v-if="info.I_BUTTON_NAME_3!=''" style="background-color: #54C3f1;text-align: center;display: inline-block;border-radius: 15px;width: 3.4rem;height: 1.3rem;line-height: 1.3rem;color: #fff;font-size: 0.7rem;" @click="openBook">{{info.I_BUTTON_NAME_3}}</span>
			</span>
		</div>




		<div class="scroll_area" style="overflow-y: auto">
			<div class="subjects" style="overflow-y: auto">
				<div class="subject">
					<div class="title_Q">
						<p>{{info.I_QUESTION}}</p>
					</div>
					<span class="I_QA_NO" style="display: none">{{info.I_QA_NO}}</span>
					<!-- 					<div class="options" v-if="isReload">
						<label v-if="info.I_CHOICE_1!=''" :class="{active:info.I_ANSWER == 'A' }" @click="clickAnswer($event)"><span
							 class="icon_yq"></span><input type="radio" name="subject1" value="A"><span>{{info.I_CHOICE_1}}</span></label>
						<label v-if="info.I_CHOICE_2!=''" :class="{active:info.I_ANSWER == 'B' }" @click="clickAnswer($event)"><span
							 class="icon_yq"></span><input type="radio" name="subject1" value="B"><span>{{info.I_CHOICE_2}}</span></label>
						<label v-if="info.I_CHOICE_3!=''" :class="{active:info.I_ANSWER == 'C' }" @click="clickAnswer($event)"><span
							 class="icon_yq"></span><input type="radio" name="subject1" value="C"><span>{{info.I_CHOICE_3}}</span></label>
						<label v-if="info.I_CHOICE_4!=''" :class="{active:info.I_ANSWER == 'D' }" @click="clickAnswer($event)"><span
							 class="icon_yq"></span><input type="radio" name="subject1" value="D"><span>{{info.I_CHOICE_4}}</span></label>
					</div> -->
					<van-radio-group v-model="radio">
						<van-radio v-if="info.I_CHOICE_1!=''" name="A" icon-size="15px">
							<div style="display: flex;flex-direction: row;align-items: top;padding-bottom: 0.5rem;">
								<div style="margin-right:0.5rem;">A</div>
								<div>{{info.I_CHOICE_1}}</div>
							</div>
						</van-radio>
						<van-radio v-if="info.I_CHOICE_2!=''" name="B" icon-size="15px">
							<div style="display: flex;flex-direction: row;align-items: top;padding-bottom: 0.5rem;">
								<div style="margin-right:0.5rem;">B</div>
								<div>{{info.I_CHOICE_2}}</div>
							</div>
						</van-radio>
						<van-radio v-if="info.I_CHOICE_3!=''" name="C" icon-size="15px">
							<div style="display: flex;flex-direction: row;align-items: top;padding-bottom: 0.5rem;">
								<div style="margin-right:0.5rem;">C</div>
								<div>{{info.I_CHOICE_3}}</div>
							</div>
						</van-radio>
						<van-radio v-if="info.I_CHOICE_4!=''" name="D" icon-size="15px">
							<div style="display: flex;flex-direction: row;align-items: top;padding-bottom: 0.5rem;">
								<div style="margin-right:0.5rem;">D</div>
								<div>{{info.I_CHOICE_4}}</div>
							</div>
						</van-radio>
					</van-radio-group>
				</div>
			</div>
		</div>
		<el-dialog title="" @close="closeDialog" id="dialog" :modal="false" width="95%" :visible.sync="dialogBookVisible">
			<iframe ref="iframe" frameborder="no" border="0" marginwidth="0" marginheight="0" scrolling="no" width="100%" height="100%"
			 :src="url"></iframe>
		</el-dialog>

		<div class="bottom_part">
			<span v-if="info.I_BUTTON_NAME_1!=''" class="prePage" @click="submit('上一题')">{{info.I_BUTTON_NAME_1}}</span>
			<span style="position: absolute;transform: translate(-50%,-50%);top: 50%;left: 50%;">{{info.I_NO_INDEX}}</span>
			<span v-if="info.I_BUTTON_NAME_2!='提交答案'" class="nextPage" @click="submit('下一题')">{{info.I_BUTTON_NAME_2}}</span>
			<span v-if="info.I_BUTTON_NAME_2!='下一题'" class="nextPage" @click="testEnd">{{info.I_BUTTON_NAME_2}}</span>
		</div>
		<!-- <button class="submit_btn" @click="submit">提交</button> -->

	</div>
</template>

<script>
	import DataRequestFactory from '@/factories/dataRequestFactory.js'
	import Footer from '../components/Footer.vue'
	import weui from 'weui.js'
	import {
		ajaxUrl
	} from '@/common/config'

	export default {
		data() {
			return {
				info: {},
				searchInput: '', //上一页的搜索条件
				I_LEVEL_CODE: '', //上一页的搜索条件
				tabFlag: '', //上一页的搜索条件
				I_FLAG: '', //上一页的搜索条件
				isReload: true,
				radio: "",

				dialogBookVisible: false,
				url: '',
			}
		},
		components: {
			Footer
		},
		created() {
			// this.searchInput = this.$route.params.searchInput
			// this.I_LEVEL_CODE = this.$route.params.I_LEVEL_CODE
			// this.tabFlag = this.$route.params.tabFlag
			// this.I_FLAG = this.$route.params.I_FLAG
			// $('.el-dialog').css('height','90%')


			this.info.I_BOOK_NO_SYS = this.$route.params.id
			if (this.info.I_BOOK_NO_SYS) {
				window.localStorage.setItem("H050020", this.info.I_BOOK_NO_SYS)
			} else {
				this.info.I_BOOK_NO_SYS = window.localStorage.getItem("H050020")
			}
			let params = {
				I_BOOK_NO_SYS: this.info.I_BOOK_NO_SYS
			}
			DataRequestFactory.I050042(params).then((response) => {
				this.info = response
			})
			// this.url = '#?id=' + this.info.I_BOOK_NO_SYS
			this.url = '/#/H050030?idd=Y&id='+this.info.I_BOOK_NO_SYS
		},
		methods: {
			// clickAnswer(e) {
			// 	if (!$(e.currentTarget).hasClass('active')) {
			// 		$(e.currentTarget).parent().find('label.active').removeClass("active")
			// 		$(e.currentTarget).addClass('active')
			// 	}
			// },
			closeDialog(e) {
				console.log("222")
				var childHtml = this.$refs.iframe.contentWindow;
				let audio = childHtml.document.getElementById('audio_top');
				console.log(audio)
				audio.pause();
			},
			handleMessage(event) {
				let data = event.data
			},
			openBook() {
				this.dialogBookVisible = true
				let that = this
				this.$nextTick(() => {
					this.$nextTick(() => {
						document.getElementsByClassName('el-dialog')[0].style.height = "96%"
						document.getElementsByClassName('el-dialog')[0].style.marginLeft = ".5rem"
						document.getElementsByClassName('el-dialog')[0].style.marginRight = ".5rem"
						document.getElementsByClassName('el-dialog')[0].style.marginBottom = "0"
						document.getElementsByClassName('el-dialog')[0].style.marginTop = "2vh"
						document.getElementsByClassName('el-dialog__header')[0].style.padding = "0"
						document.getElementsByClassName('el-dialog__headerbtn')[0].style.top = "0"
						document.getElementsByClassName('el-dialog')[0].style.overflow = "hidden"
						document.getElementsByClassName('el-dialog__body')[0].style.height = "92%"

						var childHtml = this.$refs.iframe.contentWindow;
						let audio = childHtml.document.getElementById('audio_top');

						if (audio == undefined) {
							let loading = weui.loading('loading');
							setTimeout(function() {
								loading.hide(function() {
									console.log('`loading` has been hidden');
								});
							}, 2000);
						}

						
					})
					let iframeWin = that.$refs.iframe.contentWindow;
					console.log(iframeWin)
					iframeWin.postMessage("haha", '*');


					// console.log(audio==undefined)
					// do{
					// 	console.log("audio==undefined")
					// }
					// while(audio!=undefined)

				})
			},

			submit(buttonName) {
				let $subject = $(".subject")
				let no = $subject.find(".I_QA_NO")[0].textContent
				// let answer = ""
				// if ($subject.find(".options label.active").length != 0) {
				// 	answer = $subject.find(".options label.active input[type=radio]")[0].value
				// }
				// console.log("你选择:"+this.radio)
				let params = {
					I_BOOK_NO_SYS: this.info.I_BOOK_NO_SYS,
					I_QA_NO: no,
					I_ANSWER: this.radio,
					I_BUTTON_NAME: buttonName
				}
				DataRequestFactory.I050042(params).then((response) => {
					// if(response.resultCode == '0') {
					//   this.$router.push({name:'H050050', params: {id: this.info.I_BOOK_NO_SYS,searchInput:this.searchInput,I_LEVEL_CODE:this.I_LEVEL_CODE,I_FLAG:this.I_FLAG,tabFlag:this.tabFlag}})
					// }
					// $(".options").find('label.active').removeClass("active")
					this.radio = ""
					// console.log("你选择:"+ this.radio, "数据库:"+response.I_ANSWER)
					this.info = response
					this.isReload = false
					this.$nextTick(() => {
						this.isReload = true
					})
					this.radio = response.I_ANSWER
				})
			},
			testEnd() {
				let that = this
				weui.confirm('提交并查看成绩', function() {
					// console.log('yes')
					let $subject = $(".subject")
					let no = $subject.find(".I_QA_NO")[0].textContent
					// let answer = ""
					// if ($subject.find(".options label.active").length != 0) {
					// 	answer = $subject.find(".options label.active input[type=radio]")[0].value
					// }
					let params = {
						I_BOOK_NO_SYS: that.info.I_BOOK_NO_SYS,
						I_QA_NO: no,
						I_ANSWER: that.radio
					}
					DataRequestFactory.I050043(params).then((response) => {
						if (response.resultCode == 0) {
							that.$router.push({
								name: 'H050050',
								params: {
									id: that.info.I_BOOK_NO_SYS,
								}
							})
						}
					})
				}, function() {
					// console.log('no')
					return
				}, {
					title: '测试完成'
				});
			}
			// submit() {
			//   var $subject = $(".subject")
			//   let dataList = []
			//   for(let i = 0; i< $subject.length; i++) {
			//     let obj = {}
			//     var no = $subject.eq(i).find(".I_QA_NO")[0].textContent
			//     let answer = ""
			//     if($subject.eq(i).find(".options label.active").length != 0) {
			//       answer = $subject.eq(i).find(".options label.active input[type=radio]")[0].value
			//     }
			//     obj.I_QA_NO = no
			//     obj.I_ANSWER = answer
			//     dataList.push(obj)
			//   }

			//   let params = {
			//     I_BOOK_NO_SYS: this.info.I_BOOK_NO_SYS,
			//     dataCount: this.info.dataCount,
			//     dataList: dataList
			//   }


			//   DataRequestFactory.I050041(params).then((response) => {
			//     if(response.resultCode == '0') {
			//       this.$router.push({name:'H050050', params: {id: this.info.I_BOOK_NO_SYS,searchInput:this.searchInput,I_LEVEL_CODE:this.I_LEVEL_CODE,I_FLAG:this.I_FLAG,tabFlag:this.tabFlag}})
			//     }
			//   })
			// }
		},
		mounted() {
			let screenHeight = window.innerHeight;
			let fontSize = getComputedStyle(window.document.documentElement)['font-size']
			let heightDiff = screenHeight - parseInt(fontSize) * 3.8
			$(".scroll_area").css("height", heightDiff + "px")


			// window.addEventListener('message', this.handleMessage) // 监听iframe的事件
			// this.iframeVue = this.$refs.iframe.contentWindow

			// document.getElementsByClassName('el-dialog')[0].style.height = "80%"
			// document.getElementsByClassName('el-dialog__body')[0].style.height = "100%"
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	@import '../assets/css/pages/H050040.css';
	@import '../assets/css/common.css';

	.van-radio-group {
		display: flex;
		flex-direction: column;
		/* justify-content: space-around; */
		padding: 1rem;
	}

	.van-radio {
		margin: 1rem;
		display: flex;
		flex-direction: row;
		align-items: baseline;
	}
</style>



// WEBPACK FOOTER //
// src/pages/H050040.vue